import { Card, CardBody } from 'reactstrap';

const MessageSkeleton = () => (
    <Card>
        <CardBody>
            <div className="d-flex align-items-center mb-4">
                <div
                    className="dt-field dt-skeleton me-3"
                    style={{ width: '48px', height: '48px', borderRadius: '50%' }}
                />
                <div className="flex-grow-1">
                    <div className="dt-field dt-skeleton mb-2" style={{ width: '30%', height: '18px' }} />
                    <div className="dt-field dt-skeleton" style={{ width: '40%', height: '14px' }} />
                </div>
            </div>
            <div className="dt-field dt-skeleton mb-3" style={{ width: '60%', height: '28px' }} />
            <div className="dt-field dt-skeleton mb-2" style={{ width: '100%', height: '16px' }} />
            <div className="dt-field dt-skeleton mb-2" style={{ width: '100%', height: '16px' }} />
            <div className="dt-field dt-skeleton mb-2" style={{ width: '90%', height: '16px' }} />
            <div className="dt-field dt-skeleton" style={{ width: '70%', height: '16px' }} />
        </CardBody>
    </Card>
);

export default MessageSkeleton;
